import ArticlePlayer from '@/components/article-player/ArticlePlayer.vue';

class ArticlePlayerProvider {
  videoPlayer: ArticlePlayer;
}

const articlePlayerProvider = new ArticlePlayerProvider();
export default articlePlayerProvider;
